export const ASPECT_RATIO = {
  ARTICLE: 1.8,
  NO_RATIO: 0,
  SQUARE: 1,
  KEY_STATISTICS_CIRCLE: 0.984,
  TEAM_MEMBER_IMAGE: 1.053
}

export const REQUIRED_DIMENSIONS_BY_RATIO = {
  '1.8': {
    minWidth: 900,
    minHeight: 500
  }
}

export function getDimensionsByRatio(ratio) {
  if (!ratio) return null

  return REQUIRED_DIMENSIONS_BY_RATIO[ratio.toString()] || null
}
